import SoilSelector from './soilSelector'

export default SoilSelector